import React, { Component } from "react";
import FeaturesService from "../../../services/featuresService";

function getMatchingInterpretation(referenceRanges, value) {
  if (!referenceRanges || !referenceRanges.length || value === "" || value == null) {
    return null;
  }
  let numVal = Number(value);
  if (isNaN(numVal)) return null;
  for (let i = 0; i < referenceRanges.length; i++) {
    let range = referenceRanges[i];
    if (!range.snomedInterpretation) continue;
    let min = range.min != null ? Number(range.min) : Number(range.minDouble);
    let max = range.max != null ? Number(range.max) : Number(range.maxDouble);
    if (numVal >= min && numVal <= max) {
      return range.snomedInterpretation;
    }
  }
  return null;
}

class QuestionInteger extends Component {
  handleKeyUpBlur = () => {
    let { question, validateQuestions } = this.props;
    if (question.answers && question.answers[0]) {
      validateQuestions();
    }
  };
  render() {
    let { question, setData, validateQuestions } = this.props;
    let value =
      question.answers && question.answers[0]
        ? question.answers[0].valueInteger
        : "";
    let interpretation =
      FeaturesService.isTerminologyEnabled()
        ? getMatchingInterpretation(question.referenceRanges, value)
        : null;

    return (
      <React.Fragment>
        <input
          value={value}
          type="number"
          onChange={(e) => {
            setData({
              valueInteger: e.target.value,
            });
          }}
          onBlur={this.handleKeyUpBlur}
          defaultValue={question.initialValue}
          className={"form-control"}
        />
        {interpretation && (
          <small className="text-muted mt-1 d-block">
            {interpretation.display} ({interpretation.code})
          </small>
        )}
      </React.Fragment>
    );
  }
}

export default QuestionInteger;
